export const AddCurriculumConfig = {
  "Add Bundle": {
    columns: 1,
    gap: "16px",
    hideTitle: true,
  },
}
export const USER_FORM_SECTION_CONFIG = {
  "User Details": {
    columns: 2,
    gap: "10px",
    hideTitle: true,
  },
};

export const courseSectionConfig = {
  "Course Details": { columns: 2 },
};